import React from 'react'
import { Position } from '@xyflow/react'
import type { ProjectLabel } from '@bandos/shared'
import {
  CollapsedViewWrapper,
  CollapsedCircle,
  CollapsedTagsContainer,
  CollapsedTagCircle,
  CollapsedTargetHandle,
  CollapsedSourceHandle,
} from '../styles/CollapsedStyles'

interface CollapsedViewProps {
  icon: React.ComponentType<{ size: number; color: string; strokeWidth?: number }>
  iconColor: string
  labels: ProjectLabel[] | undefined
  hideSourceHandle: boolean
}

export const CollapsedView = React.memo(
  ({ icon: CategoryIconComponent, iconColor, labels, hideSourceHandle }: CollapsedViewProps) => (
    <CollapsedViewWrapper>
      {/* Icon circle at center - tags are children */}
      <CollapsedCircle $iconColor={iconColor}>
        <CategoryIconComponent size={16} color={iconColor} />
        {/* Tag circles - below the icon */}
        {labels && labels.length > 0 && (
          <CollapsedTagsContainer>
            {labels.map((label) => (
              <CollapsedTagCircle key={label.id} $color={label.color} />
            ))}
          </CollapsedTagsContainer>
        )}
      </CollapsedCircle>
      {/* Handles - fixed positions at icon center */}
      <CollapsedTargetHandle
        type="target"
        position={Position.Left}
        id="target"
        isConnectable={false}
      />
      {!hideSourceHandle && (
        <CollapsedSourceHandle
          type="source"
          position={Position.Right}
          id="right-source"
          isConnectable={false}
        />
      )}
    </CollapsedViewWrapper>
  )
)
